import React, { Suspense } from 'react';
import { Route, BrowserRouter as Router, Switch, Redirect } from 'react-router-dom';

// import Login from "./containers/login/login";
// import Mpin from './containers/mpin/Mpin';
// import Orders from './containers/orders/Orders';
import Signup from './containers/signup/signup';
import Loading from './components/loading/Loading';
import ProductList from './containers/product-list';
import CartPage from './containers/cart-page';
import PodList from './containers/pod-list';
import MakePayment from './containers/make-payment';
import InvoicePage from './containers/invoice-page';
import PaymentSuccess from './containers/payment-success';
import ProcessPayment from './containers/process-payment';
import OrderHistory from './containers/order-history';
import Passbook from './containers/passbook';
import Feedback from './containers/feedback';
import { Wallet, LoadMoney, LoadMoneyPayment, Withdraw } from './containers/wallet';
import ProcessWalletPayment from './containers/process-wallet-payment';
import Terms from './components/terms/Terms';
import AboutUs from './components/about-us/AboutUs';
import ContactUs from './components/contactus/ContactUs';
import Shipping from './components/shipping/Shipping';
import TokenAuth from './containers/token-auth/TokenAuth'
import ConfirmMachine from './containers/confirm-machine/ConfirmMachine';
import TipsPage from './containers/tips-page/TipsPage';
import ViewAddresses from './containers/view-addresses';
import BrowseMachines from './containers/browse-machines';
import UserAddress from './containers/user-address'
import ProcessOrder from "./containers/process-order-page/ProcessOrder";

function Routes() {
	return (
		<Router>
			<Suspense fallback={<Loading message='Loading' style={{ color: '#fff' }} />}>
				<Switch>
					<Redirect exact from='/' to='/browse' />
					<Route id='login' path='/login' component={Signup} />
					<Route id='browse' path='/browse' component={BrowseMachines} />
					{/* <Route id="signup" path="/signup" component={Signup} /> */}
					{/* <Route id="forgot-mpin" path="/forgot-mpin" component={Signup} /> */}
					{/* <Route id="setMpin" path="/set-mpin" component={Mpin} /> */}
					{/* <Route id="resetMpin" path="/reset-mpin" component={Mpin} /> */}
					<Route id='products' path='/products' component={ProductList} />
					<Route exact id='cart' path='/cart' component={CartPage} />
					<Route exact id='cart-address' path='/cart/select-address' component={CartPage} />
					<Route id='podlist' path='/podlist/:podId?' component={PodList} />
					<Redirect exact from='/orders' to='/orders/last-order' />
					<Redirect from='/l/:sOrderid' to='/orders/:sOrderid/invoice' />
					<Route exact id='orderInvoice' path='/orders/:orderId/invoice' component={InvoicePage} />
					<Route exact id='processOrder' path='/orders/:orderId/process' component={ProcessOrder} />
					<Route exact id='cartPayment' path='/order/payment' component={MakePayment} />
					<Route exact id='orderPayment' path='/cart/payment' component={MakePayment} />
					<Route exact id='processPayment' path='/paytm/process-payment' component={ProcessPayment} />
					<Route exact id='processPayment' path='/juspay/process-payment' component={ProcessPayment} />
					<Route exact id='processPayment' path='/ola/process-payment' component={ProcessPayment} />
					<Route exact id='paymentsuccess' path='/payment-success' component={PaymentSuccess} />
					<Route exact id='orderpin' path='/order-mpin' component={PaymentSuccess} />
					<Route id='orderHistory' path='/orders/order-history' component={OrderHistory} />
					<Route id='passbook' path='/passbook' component={Passbook} />
					<Route id='feedback' path='/orders/:orderId/help' component={Feedback} />
					<Route id='wallet' path='/wallet' exact component={Wallet} />
					<Route id='wallet-loadMoney' path='/wallet/load-money' component={LoadMoney} />
					<Route id='wallet-payment' path='/wallet/payment' component={LoadMoneyPayment} />
					<Route id='wallet-payment' path='/wallet/transfer-out' component={Withdraw} />
					<Route id='auth' exact path='/a/:token' component={TokenAuth} />
					<Route
						exact
						id='processWalletPayment'
						path='/paytm/process-wallet-payment'
						component={ProcessWalletPayment}
					/>
					<Route
						exact
						id='processWalletPayment'
						path='/juspay/process-wallet-payment'
						component={ProcessWalletPayment}
					/>
					<Route exact id='processWalletPayment' path='/ola/process-wallet-payment' component={ProcessWalletPayment} />
					<Route exact id='termsconditions' path='/terms-and-conditions' component={Terms} />
					<Route exact id='aboutus' path='/aboutus' component={AboutUs} />
					<Route exact id='contactus' path='/contactus' component={ContactUs} />
					<Route exact id='shipping' path='/shipping' component={Shipping} />
					<Route exact id='confirmmachine' path='/confirm-pod' component={ConfirmMachine} />
					<Route exact id='tips' path='/tips' component={TipsPage} />
					<Route exact id='view-address' path='/address' component={ViewAddresses} />
					<Redirect from='/affl/:store/:category?' to='/affiliate/:store/:category?'/>
					<Route id='affiliate-products' path='/affiliate/:store/:category?' component={ProductList} />
					<Route exact id='update-address' path='/address/update' component={UserAddress} />
					<Route exact id='update-places-address' path='/address/update/places' component={UserAddress} />
					<Redirect from='/*' to='/browse' />
				</Switch>
			</Suspense>
		</Router>
	);
}

export default React.memo(Routes);
